import type React from 'react';

import { useTranslation } from 'react-i18next';

import { BaseResultItem } from './base-result-item/BaseResultItem';
import type { TResultStatus } from '../../check-tag/CheckTag';
import { CheckTag } from '../../check-tag/CheckTag';

interface LivenessResultItemProps {
  prediction: string;
  score: number;
}

const kindMap: Record<string, TResultStatus> = {
  spoof: 0,
  real: 1,
  unknown: 2,
};

function LivenessResultItem({
  prediction,
  score,
}: LivenessResultItemProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseResultItem
      label={t('liveness')}
      score={score}
      tag={(
        <CheckTag
          kind={kindMap[prediction] as TResultStatus}
          value={t(`checks:result panel.results.liveness_states.${prediction}`)}
        />
      )}
    />
  );
}

export { LivenessResultItem };
